import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import ArchiveProjectsTopSection from 'components/modules/project-management/ArchiveProjectsTopSection';
import GTable from 'components/tables/GTable';
import { projectListTableColumns } from 'components/tables/ProjectListTable';
// import { PERMISSIONS } from 'constants/permissions';
import { homepageBreadcrumbItems } from 'data/commonData';
// import { usePermissions } from 'hooks/usePermissions';
import { useMemo, useState } from 'react';
import { Placeholder } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { GET_JOBS_QUERY } from 'services/api/job';

const ArchiveListView = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { data: jobs, isLoading } = useQuery('getJobs', GET_JOBS_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const archivedJobs = jobs?.data?.filter(
    job =>
      job?.jobStage?.name?.toLowerCase() === 'closed' ||
      job?.jobStage?.name?.toLowerCase() === 'cancelled'
  );

  const filteredJobs = archivedJobs?.filter(job => {
    const searchString = searchTerm.toLowerCase();
    return (
      job?.title?.toLowerCase().includes(searchString) ||
      job?.well?.toLowerCase().includes(searchString) ||
      job?.jobNumber?.toLowerCase().includes(searchString) ||
      job?.customer?.organizationName?.toLowerCase().includes(searchString) ||
      job?.location?.location?.toLowerCase().includes(searchString)
    );
  });

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  // const [canCreateNewProject, canEditArchiveProject] = usePermissions([
  //   PERMISSIONS.DASHBOARD.ACTIVE_JOBS.CREATE,
  //   PERMISSIONS.DASHBOARD.ARCHIVE_JOBS.UPDATE
  // ]);

  const columns = useMemo(() => {
    return projectListTableColumns(true, true);
  }, []);

  return (
    <div>
      <PageBreadcrumb items={homepageBreadcrumbItems} />
      <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
        <h2 className="mb-0">
          <span className="me-3">Archived Projects</span>{' '}
          <span className="fw-normal text-700">({archivedJobs?.length})</span>
        </h2>
        <Link className="btn btn-primary px-5" to="/home/apps/job/create">
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Add new job
        </Link>
      </div>
      <div className="d-flex justify-content-start">
        <ArchiveProjectsTopSection activeView="list" onSearch={handleSearch} />
      </div>
      {isLoading ? (
        <div className="g-3 mt-8 mb-8">
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        </div>
      ) : (
        <GTable
          data={filteredJobs ?? []}
          columns={columns}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default ArchiveListView;
